<template>
  <div>
    404
    <br />页面没找到
  </div>
</template>
<script>
export default {
  name: 'notFound'
}
</script>
<style scoped>

</style>
